export { default as Component } from "./Tabs.svelte";
export const modes = ["static"];
